import React from 'react';
import { Tag, Space } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { EDIT_HEATMAPS, EDIT_SESSION_RECORDINGS, SUPER_USER } from 'shared/constants/permissions';
import Heatmap from './Heatmap';
import HsrDashboard from './HsrDashboard';
import SessionRecording from './SessionRecording';
import HeatmapList from './HeatmapList';
import SessionRecordingList from './SessionRecordingList';
import SessionRecordingTable from './SessionRecordingTable';

const routes = [
  {
    path: 'dashboard',
    label: 'Dashboard',
    component: HsrDashboard,
  },
  {
    path: 'heatmaps',
    label: 'Heatmaps',
    link: false,
    component: Heatmap,
    emptyLabel: 'No heatmaps',
  },
  {
    path: 'session-recordings',
    label: 'Recordings',
    link: false,
    component: SessionRecording,
    emptyLabel: 'No recordings',
  },
  {
    path: 'session-recordings-new',
    label: (
      <Space>
        Recordings
        <Tag color="success">New</Tag>
      </Space>
    ),
    link: false,
    component: SessionRecordingTable,
    emptyLabel: 'No recordings',
    dataSourcePermission: SUPER_USER,
  },
  {
    type: 'divider',
  },
  {
    path: 'manage-heatmaps',
    label: 'Manage heatmaps',
    icon: <EditOutlined />,
    component: HeatmapList,
    dataSourcePermission: EDIT_HEATMAPS,
  },
  {
    path: 'manage-session-recordings',
    label: 'Manage recordings',
    icon: <EditOutlined />,
    component: SessionRecordingList,
    dataSourcePermission: EDIT_SESSION_RECORDINGS,
  },
];

export default routes;
